import { Flashcard } from "./flashcard.model";
import { Learnset } from "./learnset.model";

export class Course {
  id: number | null;
  name: string;
  userId: number | null;
  learnsetCount: number = 0;
  color: string;
  isExpanded: boolean = false;
  learnsets: Learnset[] = [];
  examTemplates: any[] = [];
  openCards: number = 0;
  openCardsTime: number = 0;

  constructor(id: number | null, name: string, userId: number | null, learnsetCount: number, color: string, learnsets: any[], examTemplates: any[], openCards: number, openCardsTime: number) {
    this.id = id;
    this.name = name;
    this.userId = userId;
    this.learnsetCount = learnsetCount;
    this.color = color;
    this.learnsets = learnsets?.length > 0 ? learnsets.map(learnset => Learnset.constructLearnset(learnset)) : [];
    this.examTemplates = examTemplates?.length > 0 ? examTemplates.map(examTemplate => examTemplate) : [];
    this.openCards = openCards;
    this.openCardsTime = openCardsTime;
  }

  public static constructCourse(raw: any): Course {
    return new Course(
      raw.id,
      raw.name,
      raw.userId,
      raw.learnsetCount,
      raw.color,
      raw.learnsets?.length > 0 ? raw.learnsets.map((learnset: any) => Learnset.constructLearnset(learnset)) : [],
      raw.examTemplates?.length > 0 ? raw.examTemplates.map((examTemplate: any) => examTemplate) : [],
      raw.openCards,
      raw.openCardsTime
    );
  }
}